import React, { useState } from "react";
import "./Viewall.css";
import { useCart } from "./CartContext";
import { useCountry } from "./CountryContext";
import { useNavigate } from "react-router-dom";

// =========================
// PRODUCT IMAGE IMPORTS
// =========================

import product1 from "../Images/blue1.jpg";
import product2 from "../Images/orange5.jpg";
import product3 from "../Images/yellow5.jpg";
import product4 from "../Images/blue2.jpg";
import product5 from "../Images/darkgreen2.jpg";
import product6 from "../Images/green1.jpg";
import product7 from "../Images/image30.png";
import product8 from "../Images/image33.png";
import product9 from "../Images/yellow5.jpg";
import product10 from "../Images/grey1.jpg";
import product11 from "../Images/image41.png";
import product12 from "../Images/image39.png";
import product13 from "../Images/south8.jpeg";
import product14 from "../Images/yellow9.jpg";
import product15 from "../Images/image30.png";
import product16 from "../Images/south11.jpeg";
import product17 from "../Images/green7.jpg";
import product18 from "../Images/image31.png";
import product19 from "../Images/orange10.jpg";
import product20 from "../Images/red7.jpg";
import product21 from "../Images/yellowgreen1.png";
import product22 from "../Images/orange3.jpg";
import product23 from "../Images/image38.png";
import product24 from "../Images/green5.jpg";
import product25 from "../Images/darkgreen1.jpg";
import product26 from "../Images/mix1.jpg";
import product27 from "../Images/darkgreen3.jpg";
import product28 from "../Images/red3.jpg";
import product29 from "../Images/orange4.jpg";
import product30 from "../Images/yellow8.jpg";
import product31 from "../Images/red3.jpg";
import product32 from "../Images/black1.jpg";
import product33 from "../Images/blue6.jpg";


const ViewallProducts = () => {

  // =========================
  // NAVIGATION
  // =========================

  const navigate = useNavigate();


  // =========================
  // CART
  // =========================

  const { addToCart } = useCart();


  // =========================
  // COUNTRY / CURRENCY
  // =========================

  const { formatPrice } = useCountry();


  // =========================
  // PRODUCTS
  // Base prices are in GBP (£)
  // =========================

  const products = [
    {
      id: 101,
      image: product1,
      name: "African Print Dress",
      price: "£49.99",
      oldPrice: "£69.99",
    },
    {
      id: 102,
      image: product2,
      name: "African Elegant Dress",
      price: "£59.99",
      oldPrice: "£79.99",
    },
    {
      id: 103,
      image: product3,
      name: "African Fashion Dress",
      price: "£54.99",
      oldPrice: "£74.99",
    },
    {
      id: 104,
      image: product4,
      name: "Traditional African Dress",
      price: "£64.99",
      oldPrice: "£84.99",
    },
    {
      id: 105,
      image: product5,
      name: "African Maxi Dress",
      price: "£69.99",
      oldPrice: "£89.99",
    },
    {
      id: 106,
      image: product6,
      name: "African Pattern Dress",
      price: "£49.99",
      oldPrice: "£65.99",
    },
    {
      id: 107,
      image: product7,
      name: "Luxury African Dress",
      price: "£79.99",
      oldPrice: "£99.99",
    },
    {
      id: 108,
      image: product8,
      name: "African Occasion Dress",
      price: "£74.99",
      oldPrice: "£94.99",
    },
    {
      id: 109,
      image: product9,
      name: "African Print Gown",
      price: "£89.99",
      oldPrice: "£109.99",
    },
    {
      id: 110,
      image: product10,
      name: "African Casual Dress",
      price: "£44.99",
      oldPrice: "£59.99",
    },
    {
      id: 111,
      image: product11,
      name: "African Designer Dress",
      price: "£84.99",
      oldPrice: "£109.99",
    },
    {
      id: 112,
      image: product12,
      name: "African Long Dress",
      price: "£69.99",
      oldPrice: "£89.99",
    },
    {
      id: 113,
      image: product13,
      name: "African Floral Dress",
      price: "£54.99",
      oldPrice: "£69.99",
    },
    {
      id: 114,
      image: product14,
      name: "African Modern Dress",
      price: "£59.99",
      oldPrice: "£79.99",
    },
    {
      id: 115,
      image: product15,
      name: "African Premium Dress",
      price: "£94.99",
      oldPrice: "£119.99",
    },
    {
      id: 116,
      image: product16,
      name: "African Party Dress",
      price: "£74.99",
      oldPrice: "£94.99",
    },
    {
      id: 117,
      image: product17,
      name: "African Cotton Dress",
      price: "£49.99",
      oldPrice: "£64.99",
    },
    {
      id: 118,
      image: product18,
      name: "African Summer Dress",
      price: "£59.99",
      oldPrice: "£74.99",
    },
    {
      id: 119,
      image: product19,
      name: "African Heritage Dress",
      price: "£79.99",
      oldPrice: "£99.99",
    },
    {
      id: 120,
      image: product20,
      name: "African Classic Dress",
      price: "£69.99",
      oldPrice: "£89.99",
    },
    {
      id: 121,
      image: product21,
      name: "African Printed Gown",
      price: "£89.99",
      oldPrice: "£109.99",
    },
    {
      id: 122,
      image: product22,
      name: "African Evening Dress",
      price: "£79.99",
      oldPrice: "£99.99",
    },
    {
      id: 123,
      image: product23,
      name: "African Style Dress",
      price: "£64.99",
      oldPrice: "£84.99",
    },
    {
      id: 124,
      image: product24,
      name: "African Couture Dress",
      price: "£99.99",
      oldPrice: "£129.99",
    },
    {
      id: 125,
      image: product25,
      name: "African Beauty Dress",
      price: "£69.99",
      oldPrice: "£89.99",
    },
    {
      id: 126,
      image: product26,
      name: "African Elegant Gown",
      price: "£89.99",
      oldPrice: "£109.99",
    },
    {
      id: 127,
      image: product27,
      name: "African Statement Dress",
      price: "£74.99",
      oldPrice: "£94.99",
    },
    {
      id: 128,
      image: product28,
      name: "African Handmade Dress",
      price: "£84.99",
      oldPrice: "£104.99",
    },
    {
      id: 129,
      image: product29,
      name: "African Signature Dress",
      price: "£94.99",
      oldPrice: "£119.99",
    },
    {
      id: 130,
      image: product30,
      name: "African Royal Dress",
      price: "£109.99",
      oldPrice: "£139.99",
    },
    {
      id: 131,
      image: product31,
      name: "African Royal Dress",
      price: "£109.99",
      oldPrice: "£139.99",
    },
    {
      id: 132,
      image: product32,
      name: "African Royal Dress",
      price: "£109.99",
      oldPrice: "£139.99",
    },
    {
      id: 133,
      image: product33,
      name: "African Royal Dress",
      price: "£109.99",
      oldPrice: "£139.99",
    },
  ];


  // =========================
  // WISHLIST
  // =========================

  const [wishlist, setWishlist] = useState([]);


  const handleWishlist = (productId) => {

    setWishlist((previous) => {

      if (previous.includes(productId)) {
        return previous.filter(
          (id) => id !== productId
        );
      }

      return [...previous, productId];

    });

  };


  // =========================
  // GET NUMERIC GBP PRICE
  // =========================

  const getBasePrice = (price) => {

    const numericPrice = parseFloat(
      String(price)
        .replace("£", "")
        .trim()
    );

    return isNaN(numericPrice)
      ? 0
      : numericPrice;

  };


  // =========================
  // OPEN PRODUCT DETAILS
  // =========================

  const handleProductClick = (productId) => {

    navigate(`/womens/${productId}`);

  };


  // =========================
  // ADD TO CART
  // =========================

  const handleAddToCart = (product) => {

    const numericPrice =
      getBasePrice(product.price);

    addToCart({
      id: product.id,
      name: product.name,
      img: product.image,
      image: product.image,
      price: numericPrice,
      oldPrice: getBasePrice(product.oldPrice),
      originalPrice: getBasePrice(product.oldPrice),
    });

    alert(
      `${product.name} added to cart!`
    );

  };


  // =========================
  // BUY NOW
  // =========================

  const handleBuyNow = (product) => {

    const numericPrice =
      getBasePrice(product.price);

    addToCart({
      id: product.id,
      name: product.name,
      img: product.image,
      image: product.image,
      price: numericPrice,
      oldPrice: getBasePrice(product.oldPrice),
      originalPrice: getBasePrice(product.oldPrice),
    });

    // Payment page
    navigate("/payment");

  };


  return (
    <main className="viewall1-page">

      {/* =========================
          PAGE HEADING
      ========================== */}

      <div className="viewall2-heading">

        <h1>
          Explore Our Collection
        </h1>

        <p>
          Discover timeless African fashion,
          crafted with elegance and style.
        </p>

      </div>


      {/* =========================
          PRODUCT GRID
      ========================== */}

      <div className="viewall3-container">

        {products.map((product) => (

          <div
            className="viewall4-card"
            key={product.id}
          >

            {/* =========================
                PRODUCT IMAGE
            ========================== */}

            <div
              className="viewall5-image-wrapper"
              onClick={() =>
                handleProductClick(product.id)
              }
              style={{
                cursor: "pointer",
              }}
            >

              <img
                src={product.image}
                alt={product.name}
                className="viewall6-image"
              />


              {/* =========================
                  WISHLIST
              ========================== */}

              <button
                type="button"
                className={`viewall7-wishlist ${
                  wishlist.includes(product.id)
                    ? "viewall7-wishlist-active"
                    : ""
                }`}
                onClick={(event) => {

                  event.stopPropagation();

                  handleWishlist(
                    product.id
                  );

                }}
                aria-label="Add to wishlist"
              >

                {wishlist.includes(product.id)
                  ? "♥"
                  : "♡"}

              </button>

            </div>


            {/* =========================
                PRODUCT DETAILS
            ========================== */}

            <div className="viewall8-info">

              {/* PRODUCT NAME */}

              <h2
                className="viewall8-product-name"
                onClick={() =>
                  handleProductClick(
                    product.id
                  )
                }
                style={{
                  cursor: "pointer",
                }}
              >
                {product.name}
              </h2>


              {/* =========================
                  PRICE
              ========================== */}

              <div className="viewall9-price">

                <span className="viewall10-current-price">

                  {formatPrice(
                    getBasePrice(
                      product.price
                    )
                  )}

                </span>

                <span className="viewall11-old-price">

                  {formatPrice(
                    getBasePrice(
                      product.oldPrice
                    )
                  )}

                </span>

              </div>


              {/* =========================
                  BUTTONS
              ========================== */}

              <div className="viewall12-buttons">

                {/* ADD TO CART */}

                <button
                  type="button"
                  className="viewall13-cart-btn"
                  onClick={() =>
                    handleAddToCart(
                      product
                    )
                  }
                >
                  Add to Cart
                </button>


                {/* BUY NOW */}

                <button
                  type="button"
                  className="viewall14-buy-btn"
                  onClick={() =>
                    handleBuyNow(
                      product
                    )
                  }
                >
                  Buy Now
                </button>

              </div>

            </div>

          </div>

        ))}

      </div>

    </main>
  );
};

export default ViewallProducts;